<template>
  <div>
    <div class="hide-on-print">
      <page-title icon="fa fa-file-alt" main="Relatórios" sub="Meta Financeira"></page-title>
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>
        <validation-observer ref="observer">
          <div class="row">
            <div class="col-6">
              <label class="form-control-label">Ano Safra<span class="text-danger">*</span></label>
              <multiselect
                v-model="filters.anosafra"
                placeholder="Selecionar Ano Safra"
                :options="anosafras"
                label="descricao"
                track-by="id"
                @input="populateLimit"
              />
            </div>
            <div class="col-6">
              <label class="form-control-label">Tipo<span class="text-danger">*</span></label>
              <multiselect
                placeholder="Selecionar tipo"
                v-model="filters.userType"
                :options="userGoalTypes"
                label="label"
                track-by="value"
                value="value"
                @input="getUserType"
                rules="required"
              />
            </div>
            <div v-if="filters.userType && filters.userType.value !== 'vegetal'" class="col-6 mt-3">
              <label class="form-control-label">{{ filters.userType.label }}</label>
              <multiselect
                placeholder="Selecionar"
                v-model="filters.users"
                :options="users"
                label="name"
                track-by="id"
                :close-on-select="false"
                :limit="1"
                :limit-text="(count) => ` + ${count}`"
                @input="getSalesman"
                :open-direction="'bottom'"
                :loading="loading.user"
                multiple
              >
                <template slot="beforeList">
                  <div
                    @click="selectAllUsers"
                    :class="allUsersSelected ? 'all-selected' : 'multiple select-all-option'"   
                    :style="allUsersSelected ? 'background-color: #e9ecef; color: #212529' : ''"
                  >
                    <span :style="allUsersSelected ? 'font-weight: 500' : ''">
                      {{ allUsersSelected ? 'Desmarcar todos' : 'Selecionar todos' }}
                    </span>
                  </div>
                </template>
              </multiselect>
            </div>
            <div class="col-6 mt-3">
              <label class="form-control-label">Até<span class="text-danger">*</span></label>
              <multiselect
                placeholder="Selecionar limite"
                v-model="filters.dateLimit"
                :options="dateLimit"
                rules="required"
              />
            </div>
            <div class="col-6 mt-3">
              <label class="form-control-label">Tipo da Meta<span class="text-danger">*</span></label>
              <multiselect
                placeholder="Selecionar tipo de meta"
                v-model="filters.tableName"
                :options="tableName"
                :close-on-select="false"
                rules="required"
                multiple
              />
            </div>
            <div class="col-6 mt-3" v-if="filters.userType && filters.userType.value == 'is_manager' && filters.users">
              <label class="form-control-label">Vendedor</label>
              <multiselect
                placeholder="Selecionar vendedor"
                v-model="filters.salesman"
                :options="salesmans"
                label="name"
                track-by="id"
                multiple
                :loading="loading.salesmans"
                :limit="1"
                :close-on-select="false"
                :limit-text="(count) => ` + ${count}`"
                @input="() => {}"
                :open-direction="'bottom'"
              >
                <template slot="beforeList">
                  <div
                    @click="selectAllSalesmans"
                    :class="allsalesmansSelected ? 'all-selected' : 'multiple select-all-option'"
                    :style="allsalesmansSelected ? 'background-color: #e9ecef; color: #212529' : ''"
                  >
                    <span :style="allsalesmansSelected ? 'font-weight: 500' : ''">
                      {{ allsalesmansSelected ? 'Desmarcar todos' : 'Selecionar todos' }}
                    </span>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </validation-observer>
        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button
            v-show="false"
            type="secondary"
            class="mr-1 mt-2"
            :disabled="isDisabled"
            @click="generatePDF"
            v-loading="loading.pdf"
          >
            Gerar PDF
          </base-button>
          <base-button
            type="secondary"
            class="ml-1 mt-2"
            :disabled="isDisabled"
            @click="generateExcel"
            v-loading="loading.excel"
          >
            Gerar Excel
          </base-button>
          <el-tooltip :disabled="!isDisabled" content="Preencha os campos obrigatórios antes de continuar." placement="top">
            <base-button :disabled="isDisabled" v-loading="loading.goals" type="primary" class="ml-2 mt-2" @click="generateReport">
              Gerar Relatório
            </base-button>
          </el-tooltip>
        </div>
      </card>
      <card v-if="goals.length > 0">
        <div class="mb-5">
          <div style="font-size: 20px; font-weight: bold; color: black;">Relatório</div>
          <div style="font-size: 12px; font-weight: bold; color: gray; text-transform: uppercase;">
            Meta Financeira - {{ currentDate | formatDate("full") }}
          </div>
        </div>
        <div class="background_table">
          <card v-for="user in goals" :key="user.id" class="mb-5">
            <el-table
              class="table-responsive"
              :data="[user]"
              v-loading="loading.goals"
              style="background: #fff;"
            >
              <el-table-column :label="labelDate" :min-height="45">
                <el-table-column :label="getRoleLabel(user)" prop="user.name" :min-width="220" />
                <template v-for="group in allGoalGroups">
                  <el-table-column
                    v-if="filters.tableName.includes('Meta') || filters.tableName.includes('TODAS')"
                    :label="`Soma Meta ${group}`"
                    :min-width="200"
                  >
                    <template v-slot="scope">
                      {{
                        (getPercentualGoalsByGroup(scope.row.goals.goal || [])[group] || 0)
                        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="filters.tableName.includes('Meta') || filters.tableName.includes('TODAS')"
                    :label="`Soma de realizado ${group}`"
                    :min-width="250"
                  >
                    <template v-slot="scope">
                      {{
                        ((scope.row.goals.goal.find(g => g.group === group) || {}).salesman_sales || 0)
                        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }}
                    </template>
                  </el-table-column>

                  <el-table-column
                    :label="`Soma Meta estratégico ${group}`"
                    :min-width="300"
                    v-if="filters.tableName.includes('Meta Estratégica') || filters.tableName.includes('TODAS')"
                  >
                    <template v-slot="scope">
                      {{
                        (getPercentualGoalsByGroup(scope.row.goals.strategic_goal || [])[group] || 0)
                        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="`Soma de realizado estratégico ${group}`"
                    :min-width="350"
                    v-if="filters.tableName.includes('Meta Estratégica') || filters.tableName.includes('TODAS')"
                  >
                    <template v-slot="scope">
                      {{
                        ((scope.row.goals.strategic_goal.find(g => g.group === group) || {}).salesman_sales || 0)
                        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }}
                    </template>
                  </el-table-column>
                </template>
                <el-table-column 
                  label="Meta Total"
                  :min-width="200"
                  v-if="filters.tableName.includes('Meta') || filters.tableName.includes('TODAS')"
                >
                  <template v-slot="scope">
                    {{
                      calculateTotalGoal(scope.row).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                    }}
                  </template>
                </el-table-column>
                <el-table-column 
                  label="Realizado Total" 
                  :min-width="200"
                  v-if="filters.tableName.includes('Meta') || filters.tableName.includes('TODAS')"
                >
                  <template v-slot="scope">
                    {{
                      calculateTotalRealized(scope.row).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                    }}
                  </template>
                </el-table-column>
                <el-table-column 
                  label="Meta Estratégica"
                  :min-width="200"
                  v-if="filters.tableName.includes('Meta Estratégica') || filters.tableName.includes('TODAS')"
                >
                  <template v-slot="scope">
                    {{
                      calculateStrategicGoal(scope.row).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Realizado Estratégico" 
                  :min-width="200"
                  v-if="filters.tableName.includes('Meta Estratégica') || filters.tableName.includes('TODAS')"
                >
                  <template v-slot="scope">
                    {{
                      calculateStrategicRealized(scope.row).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                    }}
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </card>
        </div>
      </card>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, getCurrentInstance, watch} from "vue";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import Card from "../../../components/Cards/Card.vue";
import axios from "@/backend/axios/index.js";
import store from '@/store/index.js';
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { Table, TableColumn } from 'element-ui';
import moment from "moment";

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

const ElTable = Table
const ElTableColumn = TableColumn

const observer     = ref(null);
const goalsChanged = ref(false)

const loading = ref({
  pdf:       false,
  excel:     false,
  goals:     false,
  users:     false,
  salesmans: false,
  anosafras: false,
})

const filters = ref({
  anosafra:  null,
  dateLimit: null,
  userType:  null,
  tableName: [],
  users:     [],
  salesman:  [],
})

const clearFilters = () => {
  filters.value = {
    userType:  null,
    anosafra:  null,
    dateLimit: null,
    userType:  null,
    users:     [],
    salesman:  [],
    tableName: []
  },
  observer.value.reset();
}

const goals       = ref([])
const users       = ref([])
const salesmans   = ref([])
const anosafras   = ref([])
const dateLimit   = ref([])
const currentDate = ref(null)

const formatDate = (value, option = null) => {
  if (value) {
    if(option === 'full') return moment(String(value)).format('LLLL')
  }
  return ''
}

const labelDate = computed(() => {
  return `${labelGoalType.value} - ${formatDate(currentDate.value, 'full')}`
})

const labelGoalType = computed(() => {
  const goalType = filters.value.tableName

  const hasMeta      = goalType.includes("Meta")
  const hasStrategic = goalType.includes("Meta Estratégica")
  const hasAll       = goalType.includes("TODAS")

  if (hasMeta && hasStrategic || hasAll) return "META + META ESTRATÉGICA"
  if (hasMeta) return "META"
  if (hasStrategic) return "META ESTRATÉGICA"

  return ""
})

const getRoleLabel = (data) => {
  if (goalsChanged.value = false) return;

  const userType = filters.value.userType && filters.value.userType.value

  if (data.manager) return "GERENTE COMERCIAL" 

  if (!data.manager && userType === "is_manager") {
    return "VENDEDOR" 
  }

  if (!data.manager && userType !== "is_manager") {
    return filters.value.userType.label
  }

  resetGoalsChanged()
}

watch(goals, (newGoals, oldGoals) => {
  if (newGoals !== oldGoals) {
    goalsChanged.value = true
  }
})

const resetGoalsChanged = () => {
  goalsChanged.value = false
}

const tableName = ref(['Meta', 'Meta Estratégica', 'TODAS'])
const currentUser = computed(() => getCurrentInstance().proxy.$currentUser());

const userGoalTypes = computed(() => {
  if (!(currentUser.value.is_admin || currentUser.value.is_manager)) {
    return [{ label: 'Vendedor', value: 'is_salesman'}]
  }

  return [
    { label: 'Vendedor',                    value: 'is_salesman'},
    { label: 'Gerente Comercial',           value: 'is_manager'},
    { label: 'Vegetal',                     value: 'vegetal'},
    { label: 'Gerente de Negócios',         value: 'is_mkt_manager',     job_association_category: 'mkt_manager' },
    { label: 'Gerente de Sementes Cereais', value: 'grain_manager',      job_association_category: 'grain_manager' },
    { label: 'Gerente de Sementes HF',      value: 'is_seed_manager',    job_association_category: 'grocery_manager'},
    { label: 'Gerente de Nutrição',         value: 'nutrition_manager',  job_association_category: 'nutrition_manager'},
    { label: 'Gerente de Irrigação',        value: 'irrigation_manager', job_association_category: 'irrigation_manager'},
  ]
})

const isDisabled = computed(() => {
  const requiredFields = [filters.value.dateLimit, filters.value.tableName, filters.value.anosafra, filters.value.userType];

  return requiredFields.some(field => !field || field.length === 0 || field.length === null);
})

const setCurrentAnosafra = () => {
  filters.value = {
    ...filters.value,
    anosafra: store.state.currentAnosafra,
  }
};

const dateRange = (startDate, endDate) => {
  const start = startDate.split("-")
  const end = endDate.split("-")
  const startYear = parseInt(start[0])
  const endYear = parseInt(end[0])
  const dates = []

  for (let i = startYear; i <= endYear; i++) {
    const endMonth = i !== endYear ? 11 : parseInt(end[1]) - 1
    const startMon = i === startYear ? parseInt(start[1]) - 1 : 0

    for (let j = startMon; j <= endMonth; j++) {
      const lastDay = new Date(i, j + 1, 0)
      const day = lastDay.getDate().toString().padStart(2, "0")
      const month = (j + 1).toString().padStart(2, "0")
      dates.push(`${day}/${month}/${i}`)
    }
  }

  return dates
}

const populateLimit = (value) => {
  if (value.start_date && value.end_date) {
    dateLimit.value = dateRange(value.start_date, value.end_date)
  }
}

const getAnosafras = async () => {
  loading.value.anosafras = true
  try {
    const response = await axios.get('/api/v1/anosafras')
    
    anosafras.value = response.data.anosafras
    populateLimit(filters.value.anosafra)
  } catch (error) {
    console.warn('[FinancialGoalReport][getAnosafras]', error)
  } finally {
    loading.value.anosafras = false
  }
}

const allUsersSelected = computed(() => {
  return users.value.length > 0 &&
         filters.value.users &&
         filters.value.users.length === users.value.length
});

const allsalesmansSelected = computed(() => {
  return salesmans.value.length > 0 &&
         filters.value.salesman &&
         filters.value.salesman.length === salesmans.value.length
});

const selectAllUsers = async () => {
  if (allUsersSelected.value) {
    filters.value.users = [];
    filters.value.salesman = [];
  } else {
    filters.value.users = [...users.value];
    await getSalesman(filters.value.users);
  }
};

watch(() => filters.value.anosafra, (newAnoSafra) => {
  if (newAnoSafra && filters.value.userType) {
    getUserType(filters.value.userType)
  }
})

const getUserType = async (userType) => {
  if (filters.value.userType.value === "vegetal") return;

  loading.value.users = true
  filters.value.users = null

  const q = {
    anosafra_id: filters.value.anosafra.id,
    status: true, 
  }

  if (userType.job_association_category) { 
    q.job_association_category = userType.job_association_category
  } else {
    q[userType.value] = true
  }

  try {
    const response = await axios.get("/api/v1/users", {
      params: {
        unpaged: true, 
        q: q
      }
    })

    users.value = response.data
  } catch (error) {
    console.error('[FinancialGoalReport][getAnosafras]', error)
  } finally {
    loading.value.users = false
  }
}

const selectAllSalesmans = () => {
  if (allsalesmansSelected.value) {
    filters.value.salesman = [];
  } else {
    filters.value.salesman = [...salesmans.value];
  }
};

const getSalesman = async (managers) => {
  if (filters.value.userType.value !== 'is_manager') return

  const managerIds = managers.map(m => m.id)
  filters.value.salesman = []
  loading.value.salesmans = true

  try {
    const response = await axios.get("/api/v1/users", {
      params: {
        unpaged: true,
        q: {
          anosafra_id: filters.value.anosafra.id,
          is_salesman: true,
          status: true,
          manager_id: managerIds,
        }
      }
    })

    salesmans.value = response.data
  } catch (error) {
    console.error('[FinancialGoalReport][getAnosafras]', error)
  } finally {
    loading.value.salesmans = false
  }
}

// const formatParams = () => {
//   const userType = filters.value.userType && filters.value.userType.value

//   const params = {
//     goal: {
//       teable_name: filters.value.tableName,
//       anosafra_id: filters.value.anosafra.id,
//       dateLimit: filters.value.dateLimit,
//     },
//     filter: {
//       date_limit: filters.value.dateLimit,
//     },
//   }

//   if (userType === 'is_salesman') {
//     const usersFiltered = filters.value.users || []
//     const noSalesmanSelected = usersFiltered.length === 0

//     params.goal.salesman_id = noSalesmanSelected
//       ? users.value.map(u => u.id)
//       : usersFiltered.map(u => u.id)
//   }

//   if (userType === 'is_manager') {
//     const usersFiltered = filters.value.users || []
//     const noManagerSelected = usersFiltered.length === 0

//     params.goal.manager_id = noManagerSelected
//       ? users.value.map(u => u.id)
//       : usersFiltered.map(u => u.id)

//     params.filters = {
//       ...params.filters,
//       manager_id: filters.value.users && filters.value.users.length
//         ? filters.value.users.map(u => u.id)
//         : null
//     }

//     params.goal.salesman_id = filters.value.salesman && filters.value.salesman.length
//       ? filters.value.salesman.map(s => s.id)
//       : null
//   }

//   if (userType === 'is_mkt_manager') {
//     params.goal.mkt_manager_id = filters.value.users && filters.value.users.length
//       ? filters.value.users.map(u => u.id)
//       : null
//   }

//   if (
//     userType === 'is_seed_manager' ||
//     userType === 'grain_manager' ||
//     userType === 'nutrition_manager' ||
//     userType === 'irrigation_manager'
//   ) {
//     params.goal.seed_manager_id = filters.value.users && filters.value.users.length
//       ? filters.value.users.map(u => u.id)
//       : null
//   }

//   if (userType === 'seed_coordinator') {
//     params.goal.seed_coordinated_id = filters.value.users && filters.value.users.length
//       ? filters.value.users.map(u => u.id)
//       : null
//   }

//   params.list_salesmen = userType === 'is_manager' || userType === 'vegetal' ? true : null
//   params.list_manager  = userType === 'is_mkt_manager' || userType === 'seed_coordinator' ? true : null

//   return params
// }

const formatParams = () => {
  const userType = filters.value.userType && filters.value.userType.value

  const params = {
    "goal[teable_name]" : filters.value.tableName,
    "goal[anosafra_id]" : filters.value.anosafra.id,
    "goal[dateLimit]"   : filters.value.dateLimit,
    "filter[date_limit]": filters.value.dateLimit,
  }

  if (userType === 'is_salesman') {
    const usersFilterd = filters.value.users || []
    const noSalesmanSelected = usersFilterd.length === 0

    params["goal[salesman_id]"] = noSalesmanSelected
      ? users.value.map(u => u.id)
      : usersFilterd.map(u => u.id)
  }

  if (userType === 'is_manager') {
    const usersFilterd = filters.value.users || []
    const noManagerSelected = usersFilterd.length === 0
    
    params["goal[manager_id]"] = noManagerSelected
      ? users.value.map(u => u.id)
      : usersFilterd.map(u => u.id)
    params["filters.value[manager_id]"] = filters.value.users && filters.value.users.length
      ? filters.value.users.map(u => u.id)
      : null
    params["goal[salesman_id]"] = filters.value.salesman && filters.value.salesman.length
      ? filters.value.salesman.map(s => s.id)
      : null
  }

  if (userType === 'is_mkt_manager') {
    params["goal[mkt_manager_id]"] = filters.value.users && filters.value.users.length
      ? filters.value.users.map(u => u.id)
      : null
  }

  if (
    userType === 'is_seed_manager'   ||
    userType === 'grain_manager'     ||
    userType === 'nutrition_manager' ||
    userType === 'irrigation_manager'
  ) {
    params["goal[seed_manager_id]"] = filters.value.users && filters.value.users.length
      ? filters.value.users.map(u => u.id)
      : null
  }

  if (userType === 'seed_coordinator') {
    params["goal[seed_coordinated_id]"] = filters.value.users && filters.value.users.length
      ? filters.value.users.map(u => u.id)
      : null
  }

  params["list_salesmen"] = userType === 'is_manager' || userType === 'vegetal' ? true : null
  params["list_manager"]  = userType === 'is_mkt_manager' || userType === 'seed_coordinator' ? true : null

  return params
}

const generatePDF = async () => {
  loading.value.pdf = true;
  const params = {
    ...formatParams(),
    period_percent: periodPercent.value,
    user_type: filters.value.userType.label
  };

  try {
    const response = await axios.get("/api/v1/report/ppr_goals_pdf", {
      params: params,
      responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', 'relatorio_ppr.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Erro ao gerar Relatório", error);
  } finally {
    loading.value.pdf = false;
  }
}

const generateExcel = async () => {
  loading.value.excel = true;
  const params = {
    ...formatParams(),
    period_percent: periodPercent.value, 
    user_type: filters.value.userType.label
  };
  

  try {
    const response = await axios.get("/api/v1/report/ppr_goals_xlsx", {
      params: params,
      responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', 'relatorio_metas.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Erro ao gerar Excel", error);
  } finally {
    loading.value.excel = false;
  }
}

const generateReport = async() => {

console.log("periodo", periodPercent.value)
  loading.value.goals = true
  currentDate.value   = new Date()
  const params        = formatParams()

  try {
    const response = await axios.get("/api/v1/report/goals", {
      params: params
    })

    goals.value = response.data.filter(entry => {
      const g = entry.goals;
      return g && Object.keys(g).some(key => Array.isArray(g[key]) && g[key].length > 0);
    });
    
  } catch (error) {
    console.error("Erro ao gerar Relatório", error)
  } finally {
    loading.value.goals   = false;
  }
}

const allGoalGroups = computed(() => {
  const groupSet = new Set();

  goals.value.forEach(entry => {
    const goalList = entry.goals && entry.goals.goal ? entry.goals.goal : [];
    const strategicGoalList = entry.goals && entry.goals.strategic_goal ? entry.goals.strategic_goal : [];

    goalList.forEach(g => {
      if (g.group) groupSet.add(g.group);
    });

    strategicGoalList.forEach(g => {
      if (g.group) groupSet.add(g.group);
    });
  });

  return Array.from(groupSet);
});

const getPercentualGoalsByGroup = (goalList) => {
  const adjustedGoals = {};

  goalList.forEach(goal => {
    const group = goal.group;
    if (!group) return;

    const value = Number(goal.salesman_goal || 0) * periodPercent.value;

    adjustedGoals[group] = value;
  });

  return adjustedGoals;
};

const calculateTotalGoal = (user) => {
  return allGoalGroups.value.reduce((total, group) => {
    const groupGoal = user.goals.goal.find(g => g.group === group);
    const goalValue = Number(groupGoal.salesman_goal || 0);
    return total + goalValue * periodPercent.value;
  }, 0);
};

const calculateStrategicGoal = (user) => {
  return allGoalGroups.value.reduce((total, group) => {
    const groupGoal = user.goals.strategic_goal.find(g => g.group === group);
    const goalValue = Number(groupGoal.salesman_goal || 0);
    return total + goalValue * periodPercent.value;
  }, 0);
};

const calculateTotalRealized = (user) => {
  return allGoalGroups.value.reduce((total, group) => {
    const groupGoal = user.goals.goal.find(g => g.group === group);
    const sales = Number(groupGoal.salesman_sales || 0);
    return total + sales;
  }, 0);
};

const calculateStrategicRealized= (user) => {
  return allGoalGroups.value.reduce((total, group) => {
    const groupGoal = user.goals.strategic_goal.find(g => g.group === group);
    const sales = Number(groupGoal.salesman_sales || 0);
    return total + sales;
  }, 0);
};

const getperiodPercent = (dataLimite) => {
  if (!dataLimite) return 0;

  const parts = dataLimite.split('/');
  const selectedMonth = Number(parts[1]);

  const anosafraStartMonth = 4;
  const endMonth = selectedMonth >= 4 ? selectedMonth : selectedMonth + 12;
  const quantityMonths = endMonth - anosafraStartMonth + 1;

  return quantityMonths / 12;
};

const periodPercent = computed(() => getperiodPercent(filters.value.dateLimit));

onMounted(() => {
  getAnosafras()
  setCurrentAnosafra()
  filters.value.tableName = ["Meta"]
})
</script>

<style scoped>
.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}
.multiselect__option:hover {
  background-color: #41b883  !important; 
  color: white;
} 
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}

.background_table :deep(.el-table thead.is-group th.el-table__cell) {
  background-color: white !important;
}
</style>
